import React from 'react';
import ListingsTab from '../tabs/ListingsTab';
import CertsTab from '../tabs/CertsTab';
import CardsTab from '../tabs/CardsTab';
import OrdersTab from '../tabs/OrdersTab';
import SetsTab from '../tabs/SetsTab';
import PromosTab from '../tabs/PromosTab';
import BrokersTab from '../tabs/BrokersTab';
import UsersTab from '../tabs/UsersTab';
import './AdminContent.css';

const TAB_COMPONENTS = {
    listings: ListingsTab,
    certs: CertsTab,
    cards: CardsTab,
    orders: OrdersTab,
    sets: SetsTab,
    promos: PromosTab,
    brokers: BrokersTab,
    users: UsersTab,
};

const AdminContent = ({ tab, filters, goTo }) => {
    const Component = TAB_COMPONENTS[tab] || ListingsTab;
    return (
        <main className="admin-content">
            <Component filters={filters} goTo={goTo} />
        </main>
    );
};

export default AdminContent;
